import { render } from "./Star.vue?vue&type=template&id=7e383635&scoped=true&ts=true"
import script from "./Star.vue?vue&type=script&lang=ts"
export * from "./Star.vue?vue&type=script&lang=ts"

import _style_0 from "./Star.vue?vue&type=style&index=0&id=7e383635&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-7e383635"]])

export default __exports__